export const testAttributes = {
    MULTIPLE_CTA_CONTAINER: 'multiple_article_cta_container',
    MULTIPLE_CTA_BUTTON: 'multiple_article_cta_button',
    MULTIPLE_CTA_BUTTON_ICON: 'multiple_article_cta_button_icon',
    MULTIPLE_CTA_HEAD_CONTAINER: 'multiple_article_cta_head_container',
    MULTIPLE_CTA_BODY_CONTAINER: 'multiple_article_cta_body_container',
    MULTIPLE_CTA_BODY_CONTENT_TEXT_SUBTITLE:
        'multiple_article_cta_body_content_text_subtitle',
    MULTIPLE_CTA_ACTIONS_CONTAINER: 'multiple_article_cta_actions_container',

    MULTIPLE_CTA_WIDGET: 'multiple_article_cta_widget',
    MULTIPLE_CTA_CARD: 'multiple_article_cta_card',
};

export const widgetsData = [
    {
        id: 'buy',
        title: 'Buy A Home',
        subtitle:
            'Discover mortgage options that fit your unique financial needs.',
        ctaButtonText: 'Compare Lenders',
        url: `https://mortgage.quickenloans.com/#sourceid-cta_purchase`,
    },
    {
        id: 'refinance',
        title: 'Refinance',
        subtitle:
            'Refinance your mortgage to have more money for what matters.',
        ctaButtonText: 'Get Started',
        url: `https://refinance.quickenloans.com/#sourceid-cta_refinance`,
    },
    {
        id: 'equity',
        title: 'Tap Into Equity',
        subtitle:
            'Use your home’s equity and unlock cash to achieve your goals.',
        ctaButtonText: 'Explore Options',
        url: `https://refinance.quickenloans.com/#sourceid-cta_cashout`,
    },
];

export const multiCtaEnvs = {
    production: {
        homePurchase:
            'https://mortgage.quickenloans.com/#sourceid-cta_purchase',
        homeRefinance:
            'https://refinance.quickenloans.com/#sourceid-cta_refinance',
        homeEquity: 'https://refinance.quickenloans.com/#sourceid-cta_cashout',
    },
    qa: {
        homePurchase:
            'https://qa.mortgagelhp.quickenloans.com/#sourceid-cta_purchase',
        homeRefinance:
            'https://refinance.qa.quickenloans.com/#sourceid-cta_refinance',
        homeEquity: 'https://qa.loans.quickenloans.com/#sourceid-cta_cashout',
    },
    development: {
        homePurchase:
            'https://mortgage.quickenloans.com/#sourceid-cta_purchase',
        homeRefinance:
            'https://refinance.quickenloans.com/#sourceid-cta_refinance',
        homeEquity: 'https://refinance.quickenloans.com/#sourceid-cta_cashout',
    },
    local: {
        homePurchase:
            'https://mortgage.quickenloans.com/#sourceid-cta_purchase',
        homeRefinance:
            'https://refinance.quickenloans.com/#sourceid-cta_refinance',
        homeEquity: 'https://refinance.quickenloans.com/#sourceid-cta_cashout',
    },
    localhost: {
        homePurchase:
            'https://mortgage.quickenloans.com/#sourceid-cta_purchase',
        homeRefinance:
            'https://refinance.quickenloans.com/#sourceid-cta_refinance',
        homeEquity: 'https://refinance.quickenloans.com/#sourceid-cta_cashout',
    },
};
